module.exports = __webpack_public_path__ + "static/media/Kit de Apoyo E3.f8d92e97.zip";